import { render } from "./ReceiptsNew.vue?vue&type=template&id=a1d1199e"
import script from "./ReceiptsNew.vue?vue&type=script&lang=js"
export * from "./ReceiptsNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__